import { render } from "./DocumentsDownload.vue?vue&type=template&id=02dd595c&scoped=true"
import script from "./DocumentsDownload.vue?vue&type=script&lang=js"
export * from "./DocumentsDownload.vue?vue&type=script&lang=js"

import "./DocumentsDownload.vue?vue&type=style&index=0&id=02dd595c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02dd595c"]])

export default __exports__